import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ErrorResponseDto } from '@taxora-api';
import { mapApiError } from '@taxora-shared-core/util';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandler {
  private injector = inject(Injector);

  handleHttpError(error: HttpErrorResponse): HttpErrorResponse {
    const translateService = this.injector.get(TranslateService);
    const messageService = this.injector.get(MessageService);
    const errorResp: ErrorResponseDto = error.error.error as ErrorResponseDto;
    const errorKey = mapApiError(errorResp.code);
    messageService.add({
      severity: 'error',
      summary: translateService.instant('common.error'),
      detail: translateService.instant(`common.errors.${errorKey}`),
    });

    return error;
  }
}
